'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	baseName = require('./base-name'),
	navigationEscape = require('./navigation-escape');
module.exports = function GoldDriveImportModel(config, filePicker, subscriptionModel, navigatorShim, fileModel, formatConverter, remoteImportController) {
	let profile,
		isRemoteImport = false,
		importedFileConfiguration,
		contentObj;

	const self = observable(this),
		sendError = function (reason) {
			if (reason !== 'cancel') {
				self.dispatchEvent('error', reason);
			} else {
				self.dispatchEvent('cancel');
			}
		},
		fileExtension = function (url) {
			return url && url.replace(/.*\./, '');
		},
		isMindMup = function (text) {
			try {
				const json = JSON.parse(text);
				return json.id && json.formatVersion;
			} catch (e) {
				return false;
			}
		},
		onTextFilePicked = (blob, fileInfo) => {
			const converter = {
				'mup': formatConverter.fromMup,
				'mm': formatConverter.fromMM
			};
			return navigatorShim.readFileAsText(blob)
			.then(textContent => {
				let extension = fileExtension(fileInfo.name);
				if (!converter[extension]) {
					if (isMindMup(textContent)) {
						extension = 'mup';
					} else {
						return Promise.reject('invalid-file-type');
					}
				}

				try {
					contentObj = converter[extension](textContent);
				} catch (e) {
					return Promise.reject('invalid-file-format');
				}
			})
			.then(() => self.dispatchEvent('readyToSave', baseName(fileInfo.name) || config.defaultFileTitle));
		},
		onFilePicked = function (fileInfo) {
			try {
				const blob = navigatorShim.dataURLToBlob(fileInfo.contents),
					extension = fileExtension(fileInfo.name);
				isRemoteImport = false;

				if (remoteImportController.knownImport(extension)) {
					return remoteImportController.startImport(extension, blob, {notify: (msg) => self.dispatchEvent('progress', msg)})
					.then(() => {
						isRemoteImport = true;
						self.dispatchEvent('readyToSave', baseName(fileInfo.name) || config.defaultFileTitle);
					});
				} else {
					return onTextFilePicked(blob, fileInfo);
				}

			}  catch (e) {
				return Promise.reject('invalid-file-format');
			}
		};
	subscriptionModel.addEventListener('subscribed', function (goldProfile) {
		profile = goldProfile;
	});
	subscriptionModel.addEventListener('not-authenticated notRegistered expiredSubscription', function () {
		profile = false;
	});
	self.save = function (fileName) {
		if (!profile) {
			return sendError('not-subscribed');
		}
		fileName = navigationEscape(fileName);
		if (!fileName) {
			return sendError('invalid-file-name');
		}
		if (isRemoteImport) {
			self.dispatchEvent('progress', 'Completing import, please wait...');
			return remoteImportController.finalise(profile.license, fileName)
			.then((saveConfiguration) => {
				isRemoteImport = false;
				importedFileConfiguration = saveConfiguration;
				self.dispatchEvent('complete');
			})
			.catch(sendError);
		} else {
			if (!contentObj) {
				return sendError('invalid-request');
			}
			return fileModel.createFile(fileName, false, JSON.stringify(contentObj, null, 2))
			.then((saveConfiguration) => {
				importedFileConfiguration = saveConfiguration;
				self.dispatchEvent('complete');
			})
			.catch(sendError);
		}
	};
	self.confirmSave = function () {
	};
	self.cancelSave = function () {
	};
	self.pickImport = function () {
		if (!profile) {
			return sendError('not-subscribed');
		}
		return filePicker.pickFile()
		.then(onFilePicked)
		.catch(sendError);
	};
	self.editImport = function () {
		if (importedFileConfiguration && importedFileConfiguration.id) {
			navigatorShim.redirect(config.editorUrl + '/' + importedFileConfiguration.id);
		}
	};
};
